import React, { useEffect, useState } from 'react';
import '../Referral/Referral.css';
import { useNavigate } from 'react-router-dom';
import { useAccount, useReadContract } from 'wagmi';
import VEST_ABI from '../../Utils/ABI/VestingAbi.json'
import { formatEther } from 'viem';
import NotConnect from './NotConnect';
import Loader from '../../components/Loader/Loader';

export default function Vesting() {
  const navigate = useNavigate();
  const [totalVestingData, setTotalVestingData] = useState([]);
  const [loaderDataFetch, setLoaderDataFetch] = useState(true);
  const { address } = useAccount();

  const { data: vestingData, error: vestingFetchError, isSuccess: vestingDataFetchSuccess, refetch } = useReadContract({
    address: process.env.REACT_APP_VESTING_ADDRESS,
    abi: VEST_ABI,
    functionName: 'getTotalVestDetails',
    args: [],
  })

  useEffect(() => {
    if (vestingDataFetchSuccess) {
      setTotalVestingData(vestingData?.reverse());
      setLoaderDataFetch(false);
    }

    if (vestingFetchError) {
      setLoaderDataFetch(false);
    }
  }, [vestingData, vestingDataFetchSuccess, vestingFetchError]);

  const formatEpochToDate = (epochTime) => {
    const date = new Date(epochTime * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleOpenDetails = (data) => {
    navigate(`/vesting/vesting-details/${data}`)
  }

  if (loaderDataFetch) {
    return <Loader />;
  }

  return (
    <>
      {!address ? (
        <NotConnect />
      ) : totalVestingData?.length === 0 ? (
        <NotConnect noVesting={true} />
      ) : (
        <div className="referral_container">
          <div className="vesting-list-container">
            {totalVestingData?.map((value, index) => (
              <div className='vlc-box' onClick={() => handleOpenDetails(value?.beneficiary)} key={index}>
                <h4 className='vlc-box-heading'>{value?.tokenType}</h4>

                <div className='vlc-box-total-cont'>
                  <p>
                    <span>Total Vested :</span>
                    <span>{formatEther(value?.totalAmount)}</span>
                  </p>

                  <p>
                    <span>Total Released :</span>
                    <span>{Number(formatEther(value?.releasedAmount)).toFixed(2)}</span>
                  </p>
                </div>

                <div className='vlc-box-vested-dura-cont'>
                  <span>Vested duration</span>

                  <span>{formatEpochToDate(Number(value?.startTime))} - {formatEpochToDate((Number(value?.startTime) + Number(value?.duration)))}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}




